import { TenantDto } from '@nusign/picflow-backend-types';

export const getTenantJsonLdOrg = (tenant: TenantDto) => {
  if (!tenant) return;
  const socials: string[] = [];
  if (tenant.socials.instagram) {
    socials.push(`https://www.instagram.com/${tenant.socials.instagram}`);
  }
  if (tenant.socials.facebook) {
    socials.push(`https://www.facebook.com/${tenant.socials.facebook}`);
  }
  if (tenant.socials.twitter) {
    socials.push(`https://twitter.com/${tenant.socials.twitter}`);
  }
  if (tenant.socials.linkedIn) {
    const linkedIn = tenant.socials.linkedIn;
    if (linkedIn) {
      if (linkedIn.startsWith('/in/') || linkedIn.startsWith('/company/')) {
        socials.push(`https://www.linkedin.com${linkedIn}`);
      } else {
        socials.push(`https://www.linkedin.com/company/${linkedIn}`);
      }
    }
  }
  if (tenant.socials.pinterest) {
    socials.push(`https://www.pinterest.com/${tenant.socials.pinterest}`);
  }
  if (tenant.socials.tiktok) {
    socials.push(`https://tiktok.com/@${tenant.socials.tiktok}`);
  }
  if (tenant.socials.youtube) {
    socials.push(`https://youtube.com/@${tenant.socials.youtube}`);
  }

  return {
    '@type': 'Organization',
    name: tenant.name,
    url: `https://${tenant.path}.picflow.com`,
    logo: tenant.logo_url,
    sameAs: socials,
  };
};
